export const MY_TRIPS_LINK = '/mytrips/findPnr.action';

export const DEFAULT_ERROR_MESSAGE = {
  errorMessageTitle: '',
  errorMessageDescription:
    "We're unable to display your trips at this time. Please try again later."
};
